import React from 'react';
import { GraduationCap, Briefcase, Trophy } from 'lucide-react';
import '../styles/experience.css';

const Experience = () => {
  const education = [
    {
      institution: 'Babeș-Bolyai University of Cluj-Napoca',
      degree: 'Bachelor in Artificial Intelligence',
      period: '2023 - Present',
      details: [
        'Faculty of Mathematics and Computer Science',
        'Admission Grade: 9.56',
        'First Semester: 10.00 GPA',
        'Second Semester: 9.00 GPA'
      ],
      courses: [
        'Database Systems (SQL)',
        'Object-Oriented Programming (C/C++)',
        'Data Structures & Algorithms',
        'Programming Fundamentals (Python)',
        'Advanced Programming Techniques (Java)'
      ]
    },
    {
      institution: '„Tiberiu Popoviciu" Computer Science High School',
      degree: 'High School Diploma',
      period: '2020 - 2024',
      details: [
        'Graduated with Honors - Class of 2024',
        'National Olympiad of Mathematics 2018',
        'Computer Science Olympiad Participant'
      ]
    }
  ];

  const competitions = [
    {
      name: 'Innovation Labs',
      achievement: 'Semi-Finals',
      year: '2024',
      link: null
    },
    {
      name: 'EIT Health Hackathon',
      achievement: 'Participant',
      year: '2024',
      link: 'https://verify.eu.certifyme.org/verify/f609e64b1194?s=true'
    },
    {
      name: 'Cloudflight Coding Contest (AI)',
      achievement: 'Participant',
      year: '2024',
      link: null
    }
  ];

  const workshops = [
    'YARDI Professional Workshop',
    'YONDER Technical Workshop',
    'BETFAIR Development Workshop'
  ];

  const volunteering = [
    {
      organization: 'HERMES Student Association',
      role: 'HR Department Member',
      description: 'Active member contributing to human resources initiatives and student engagement activities.'
    },
    {
      organization: '„TĂȘULEASA SOCIAL" Association',
      role: 'Environmental Volunteer',
      description: 'Participated in tree planting initiative in Triteții de Jos (2022), contributing to environmental conservation.'
    }
  ];

  return (
    <section id="experience" className="experience-section">
      <div className="experience-container">
        <div className="section-header">
          <h2 className="section-title">Experience & Education</h2>
          <div className="section-divider"></div>
        </div>

        {/* Education */}
        <div className="subsection">
          <div className="subsection-header">
            <GraduationCap size={24} />
            <h3 className="subsection-title">Education</h3>
          </div>
          <div className="timeline">
            {education.map((edu, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <h4 className="timeline-title">{edu.institution}</h4>
                    <span className="timeline-period">{edu.period}</span>
                  </div>
                  <div className="timeline-subtitle">{edu.degree}</div>
                  <ul className="timeline-list">
                    {edu.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                  {edu.courses && (
                    <div className="courses">
                      <div className="courses-title">Relevant Coursework:</div>
                      <div className="courses-list">
                        {edu.courses.map((course, idx) => (
                          <span key={idx} className="course-tag">{course}</span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Competitions */}
        <div className="subsection">
          <div className="subsection-header">
            <Trophy size={24} />
            <h3 className="subsection-title">Competitions & Hackathons</h3>
          </div>
          <div className="competitions-grid">
            {competitions.map((comp, index) => {
              const CompWrapper = comp.link ? 'a' : 'div';
              const wrapperProps = comp.link 
                ? { 
                    href: comp.link, 
                    target: '_blank', 
                    rel: 'noopener noreferrer',
                    className: 'competition-card competition-card-link'
                  }
                : { className: 'competition-card' };
              
              return (
                <CompWrapper key={index} {...wrapperProps}>
                  <div className="competition-name">{comp.name}</div>
                  <div className="competition-achievement">{comp.achievement}</div>
                  <div className="competition-year">{comp.year}</div>
                </CompWrapper>
              );
            })}
          </div>
        </div>

        {/* Workshops */}
        <div className="subsection">
          <div className="subsection-header">
            <Briefcase size={24} />
            <h3 className="subsection-title">Professional Workshops</h3>
          </div>
          <div className="workshops-list">
            {workshops.map((workshop, index) => (
              <div key={index} className="workshop-item">{workshop}</div>
            ))}
          </div>
        </div>

        {/* Volunteering */}
        <div className="subsection">
          <div className="subsection-header">
            <h3 className="subsection-title">Volunteering</h3>
          </div>
          <div className="volunteering-grid">
            {volunteering.map((vol, index) => (
              <div key={index} className="volunteer-card">
                <div className="volunteer-org">{vol.organization}</div>
                <div className="volunteer-role">{vol.role}</div>
                <p className="volunteer-desc">{vol.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;